import React from 'react';
import {Stack, styled, SxProps} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

const GuideContainer = styled(Stack)(() => ({
  flexDirection: 'column',
  gap: '4px',
  borderRadius: '8px',
  alignItems: 'center',
  textAlign: 'center',
  boxSizing: 'border-box',
}));

function Guide({
  guideTitle,
  guideDescription,
  onLearnMoreClick,
  sx,
  textSx,
}: {
  guideTitle?: string;
  guideDescription: string;
  onLearnMoreClick?: () => void;
  sx?: SxProps;
  textSx?: SxProps;
}) {
  return (
    <GuideContainer
      direction="column"
      sx={{cursor: 'auto', ...sx}}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Body
        size="md"
        color={designSystemToken('semantic.fg.secondary')}
        sx={textSx}
      >
        {guideTitle ? (
          <span style={{color: designSystemToken('semantic.fg.primary')}}>
            {translate(guideTitle)}
          </span>
        ) : null}
      </Body>
      <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
        {translate(guideDescription)}
        {onLearnMoreClick ? (
          <span
            style={{
              color: designSystemToken('semantic.fg.brand'),
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              onLearnMoreClick?.();
            }}
          >
            {` ${translate('See best practices')}`}
          </span>
        ) : null}
      </Body>
    </GuideContainer>
  );
}

export default Guide;
